import { CommentIcon,CommentIconLarge } from "../../assets/icons";

const CommentBadge = ({ count,progress }) => {
  return (
    <div className={`absolute top-1 ${progress?'top-3':''} left-1 bg-[#1E3A8A] text-white text-[10px] text-medium ${progress?'w-[44px] h-[30px]':'w-[34px] h-[20px]'}  rounded-[2px] flex gap-1 items-center justify-center`}>
      <span >{progress?CommentIconLarge: CommentIcon}</span>
     <span className={` ${progress?'text-[14px]':'text-[10px]'}`}>{count}</span>
    </div>
  );
};

export default CommentBadge;
